import { toast } from 'sonner';
import { trackStats, fmtDur } from './track';
import { sportStats } from './trackModes';
import { tourBook, tourPhotos } from './tourBook';
import { download } from './exporters';
import { APP_INFO } from './license';

const dataFile = async (url, name) => new File([await (await fetch(url)).blob()], name, { type: 'image/jpeg' });

export function tourText(t, tr) {
  const s = trackStats(tr), sp = sportStats(tr.profile, s);
  const sport = (t['trkP_' + tr.profile] || '').replace(/\s*\([^)]*\)/g, '');
  return `${t.shareTourHead} ${tr.name} – ${sport}\n${new Date(s.start).toLocaleDateString(t.locale)} · ${s.km.toFixed(1).replace('.', t.locale?.startsWith('en') ? '.' : ',')} km · ${fmtDur(s.ms)} · ↑ ${Math.round(s.up)} m${sp.pace ? ` · ${sp.pace}` : ''}${(tr.wps || []).length ? ` · ${(tr.wps || []).length} ${t.reports}` : ''}\n${t.shareFooter} ${APP_INFO.name}`;
}

// summary text + memory book PDF + up to 8 photos into the phone share sheet (WhatsApp, Signal, Telegram …)
export async function shareTourSummary(tr, project, t) {
  const text = tourText(t, tr), base = (tr.name || 'Tour').replace(/[^\w-]+/g, '_').slice(0, 40);
  const pdf = new File([await tourBook([tr], project, t, { blob: true })], `${base}_Erinnerungsbuch.pdf`, { type: 'application/pdf' });
  const pics = await Promise.all(tourPhotos(tr, project).slice(0, 8).map((m, i) => dataFile(m.data, `${base}_${i + 1}.jpg`)));
  for (const files of [[pdf, ...pics], pics, [pdf]]) {
    if (files.length && navigator.canShare?.({ files })) {
      try { await navigator.share({ files, text, title: tr.name }); } catch (e) { if (e?.name !== 'AbortError') throw e; }
      return 'shared';
    }
  }
  if (navigator.share) { try { await navigator.share({ text, title: tr.name }); } catch (e) { if (e?.name !== 'AbortError') throw e; } return 'text'; }
  download(pdf, pdf.name);
  try { await navigator.clipboard.writeText(text); } catch { /* ignore */ }
  toast.message(t.shareTourFallback, { duration: 8000 });
  return 'download';
}
